<template>
    <component :is="component.name" v-bind="component.options">
        <template v-if="component.components">
            <ComponentRenderer v-for="component in component.components" :key="component.id" :component="component" />
        </template>
    </component>
</template>

<script>
export default {
    name: 'ComponentRenderer',
    props: {
        component: Object,
        components: Array,
    },
};
</script>
